module.exports = __webpack_public_path__ + "static/disability_card_img5@2x-0e3521bc7a018bc6c0688a67f1a14870.jpg";